// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-pill {
  --au-pill-color: var(--admin-text-muted);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 18px;
  padding: 0 7px;
  border: var(--admin-border-subtle);
  border-radius: var(--admin-radius-lg);
  background: var(--admin-bg-surface-1);
  color: var(--admin-text-secondary);
  font-size: var(--admin-text-xs);
  font-weight: var(--admin-font-weight-semibold);
  line-height: 1;
  white-space: nowrap;
}

.au-pill__dot {
  width: 6px;
  height: 6px;
  border-radius: var(--admin-radius-dot);
  background: var(--au-pill-color);
}

.au-pill--critical {
  --au-pill-color: var(--admin-status-critical);
}

.au-pill--signal {
  --au-pill-color: var(--admin-status-signal);
}

.au-pill--ambient {
  --au-pill-color: var(--admin-status-ambient);
}

.au-pill--ok {
  --au-pill-color: var(--admin-status-ok);
}

.au-pill--neutral {
  --au-pill-color: rgba(255, 255, 255, 0.34);
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminPill.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,qCAAqC;EACrC,qCAAqC;EACrC,kCAAkC;EAClC,+BAA+B;EAC/B,8CAA8C;EAC9C,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":[".au-pill {\n  --au-pill-color: var(--admin-text-muted);\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 18px;\n  padding: 0 7px;\n  border: var(--admin-border-subtle);\n  border-radius: var(--admin-radius-lg);\n  background: var(--admin-bg-surface-1);\n  color: var(--admin-text-secondary);\n  font-size: var(--admin-text-xs);\n  font-weight: var(--admin-font-weight-semibold);\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.au-pill__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: var(--admin-radius-dot);\n  background: var(--au-pill-color);\n}\n\n.au-pill--critical {\n  --au-pill-color: var(--admin-status-critical);\n}\n\n.au-pill--signal {\n  --au-pill-color: var(--admin-status-signal);\n}\n\n.au-pill--ambient {\n  --au-pill-color: var(--admin-status-ambient);\n}\n\n.au-pill--ok {\n  --au-pill-color: var(--admin-status-ok);\n}\n\n.au-pill--neutral {\n  --au-pill-color: rgba(255, 255, 255, 0.34);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
